// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as SubprocessorsRouteImport } from './routes/subprocessors'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedCaptureRouteImport } from './routes/_authenticated/capture'
import { Route as AuthenticatedPeopleRouteImport } from './routes/_authenticated/people'
import { Route as AuthenticatedPipelineRouteImport } from './routes/_authenticated/pipeline'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedShareRouteImport } from './routes/_authenticated/share'
import { Route as AuthenticatedTodayRouteImport } from './routes/_authenticated/today'
import { Route as AuthenticatedTravelRouteImport } from './routes/_authenticated/travel'
import { Route as AuthenticatedContactsContactIdRouteImport } from './routes/_authenticated/contacts.$contactId'
import { Route as OauthGoogleReturnRouteImport } from './routes/oauth/google/return'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const SubprocessorsRoute = SubprocessorsRouteImport.update({
            id: '/subprocessors',path: '/subprocessors',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCaptureRoute = AuthenticatedCaptureRouteImport.update({
            id: '/capture',path: '/capture',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPeopleRoute = AuthenticatedPeopleRouteImport.update({
            id: '/people',path: '/people',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPipelineRoute = AuthenticatedPipelineRouteImport.update({
            id: '/pipeline',path: '/pipeline',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedShareRoute = AuthenticatedShareRouteImport.update({
            id: '/share',path: '/share',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTodayRoute = AuthenticatedTodayRouteImport.update({
            id: '/today',path: '/today',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTravelRoute = AuthenticatedTravelRouteImport.update({
            id: '/travel',path: '/travel',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContactsContactIdRoute = AuthenticatedContactsContactIdRouteImport.update({
            id: '/contacts/$contactId',path: '/contacts/$contactId',getParentRoute: () => AuthenticatedRoute
          })
const OauthGoogleReturnRoute = OauthGoogleReturnRouteImport.update({
            id: '/oauth/google/return',path: '/oauth/google/return',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedCaptureRoute: AuthenticatedCaptureRoute,AuthenticatedPeopleRoute: AuthenticatedPeopleRoute,AuthenticatedPipelineRoute: AuthenticatedPipelineRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedShareRoute: AuthenticatedShareRoute,AuthenticatedTodayRoute: AuthenticatedTodayRoute,AuthenticatedTravelRoute: AuthenticatedTravelRoute,AuthenticatedContactsContactIdRoute: AuthenticatedContactsContactIdRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,CookiesRoute: CookiesRoute,FaqRoute: FaqRoute,LoginRoute: LoginRoute,OnboardingRoute: OnboardingRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,SecurityRoute: SecurityRoute,SubprocessorsRoute: SubprocessorsRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,WelcomeRoute: WelcomeRoute,OauthGoogleReturnRoute: OauthGoogleReturnRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)